import React from 'react';

interface SkeletonLoaderProps {
    className?: string;
    count?: number;
    height?: string;
    width?: string;
    borderRadius?: string;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
    className = "",
    count = 1,
    height = "h-4",
    width = "w-full",
    borderRadius = "rounded"
}) => {
    return (
        <div className={`animate-pulse flex flex-col gap-2 w-full`}>
            {Array.from({ length: count }).map((_, index) => (
                <div
                    key={index}
                    className={`relative overflow-hidden bg-gray-100 dark:bg-gray-800 ${height} ${width} ${borderRadius} ${className}`}
                ></div>
            ))}
        </div>
    );
};

export default SkeletonLoader;
